import Product from "./models/Product";

const targetVersion = 7;

export class AppConfig {
  orderFields: {
    agreementKeyId: string;
    clientNameId: string;
    clientSsnId: string;
    clientAddressId: string;
    clientCredibilityId: string;
    clientZipCodeId: string;
    clientCityId: string;
    portedPhoneId: string;
    contactPhoneId: string;
  };

  demo?: boolean;

  version: number;
};

export const defaultConfig: AppConfig = {
  "orderFields": {
    "agreementKeyId": "68ad6520a40978f6cd83f39a",
    "clientSsnId": "68a5f9f00d2c96e86ad1c97b",
    "clientNameId": "68ab074a61ace60003cae38a",
    "clientCredibilityId": "68ad6571a40978f6cd83f3bb",
    "clientAddressId": "68a5f9f00d2c96e86ad1c978",
    "clientZipCodeId": "68a5f9f00d2c96e86ad1c979",
    "clientCityId": "68a5f9f00d2c96e86ad1c97a",
    "contactPhoneId": "68a5f9f00d2c96e86ad1c97c",
    "portedPhoneId": "68ad6509a40978f6cd83f37c",
  },
  "version": targetVersion,
};

type CompanyConfig = {
  company: string;
  companyShort: string;
  email: string;
  website: string;
  agreementWebsite: string;
  logoSrc: string;
  resourcesDirectory: string;
  themeColor: string;
};

export const companyConfig: CompanyConfig = {
  company: 'Alektia',
  companyShort: 'Alektia',
  email: 'support@alektia.com',
  website: 'https://www.alektia.com',
  agreementWebsite: 'https://avtal.alektia.com',
  logoSrc: require('./logos/alektia_logo.png').default,
  resourcesDirectory: 'alektia',
  themeColor: '#1b1b1b'
};